import React, { useEffect, useState, useContext } from 'react'
import {
    Box, Button, Paper, Alert,
    Typography, InputAdornment, Container, Stack, TextField,
    Radio, Divider
} from '@mui/material';
import NumberFormat from 'react-number-format';
import { useLocation, useNavigate } from 'react-router-dom';
import * as dict from '../../dictionary'
import * as api from '../../api/Paid'
import { ProfileContext } from '../../contexts/ProfileContext';
import { checkPaymentType } from '../../utils/checkPaymentType';
import { checkProductType } from '../../utils/checkProductType';
import { BackDropLoading } from '../../ui-component';
const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;
    // now make a new formatter
    return (
        <NumberFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="฿"
        />
    );
});

// NumberFormatCustom.propTypes = {
//     name: PropTypes.string.isRequired,
//     onChange: PropTypes.func.isRequired,
// };


export const AmountPayment = ({ version = '1' }) => {
    const [amount, setAmount] = useState()
    const [detail, setDetail] = useState(null)
    const [alertRequired, setAlertRequired] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const context = useContext(ProfileContext)
    const params = new URLSearchParams(location.search);
    const disableChoiceInputAmount = params.get("disableChoiceInputAmount");
    const disableMinimumAmount = params.get("disableMinimumAmount")
    const [profile, setProfile] = useState(null)
    const [radioSelected, setRadioSelected] = useState(null)
    const [loading, setLoading] = useState(false);
    const [feeForSend, setFeeForSend] = useState(0);
    const formatCurrency = (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // const feePercent = detail?.fee||0
    // const feeAmount = parseInt(detail?.balance * feePercent / 100)
    const minimumAmount = parseInt((detail?.balance * 8 )/ 100)

    const checkCompanyId = () => {
        let productType = checkProductType()
        if (productType === "rental") {
            return localStorage.getItem("cid_rental")
        }
        if (productType === "pmlite") {
            return localStorage.getItem("cid_pm")
        }
        return localStorage.getItem("cid")
    }

    const clampAmount = (rawAmount) => {
        const value = parseFloat(rawAmount);
        let clamped = rawAmount
        if (value < minimumAmount && disableMinimumAmount !== "true") {
            clamped = minimumAmount
        }
        // if (value > (detail?.balance + feeForSend)) {
        //     setAmount(detail?.balance + feeForSend)
        // }
        if (value > (detail?.totalBalance)) {
            clamped = detail?.totalBalance
        }
        return clamped
    };

    const handleBlur = () => {
        const value = parseFloat(amount);
        if (!value) {
            // setAmount(detail?.balance + feeForSend);
            setAmount(detail?.balance);
            return;
        }
        setAmount(clampAmount(amount))
    };

    const checkIfBePercentCalAnotherWay = (fee, balance, feeType) => {

        if (feeType === "Baht") return fee

        return (balance * fee) / 100

    }

    useEffect(() => {
        if (location.state) {
            let temp = location.state
            temp.fee_amount = Number(temp.fee_amount)
            setDetail(temp)
            // setFeeForSend(checkIfBePercentCalAnotherWay(temp.fee_amount, temp.balance, temp.fee_type))
        }
    }, [location.state])

    useEffect(() => {
        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }
    }, [context])

    const createOrderFor2c2pGateway = async (data) => {
        const res = await api.createOrder2c2pPaymentGateway(data)
        return res?.data.data
    }
    return (<>
        <Box sx={{ height: "calc(100vh - 60px)" }}>

            <Container maxWidth="sm" sx={{ minHeight: "100%", paddingTop: 2, paddingBottom: 5 }}>
                <Paper sx={{ borderRadius: "10px", boxShadow: "0px 0px 7px 0px #00000040", }} >
                    <Box>
                        <Stack direction={"row"} justifyContent="center">
                            <Box sx={{ width: "100%" }} paddingBottom={3}>

                                <Stack spacing={1} padding={3}>
                                    <Stack direction={"row"} justifyContent="center">

                                        <Typography fontWeight={"bold"} color="#D34E4E">{dict.Slip_TXT[profile?.language]}</Typography>
                                    </Stack>

                                    <Stack direction={"row"} justifyContent="space-between">
                                        <Typography variant="subtitle2" color="#000000"> {dict.Project_TXT[profile?.language]} </Typography>
                                        <Typography variant="subtitle2" color="#000000" fontWeight={"bold"}> {detail?.project_name} </Typography>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent="space-between">
                                        <Typography variant="subtitle2" color="#000000"> {checkProductType() === "rental" ? dict.Rental_Unit_TXT[profile?.language] : dict.Unit_TXT[profile?.language]}</Typography>
                                        <Typography variant="subtitle2" color="#000000" fontWeight={"bold"}> {detail?.unit_number} </Typography>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent="space-between">
                                        <Typography variant="subtitle2" color="#000000"> {dict.PayName_TXT[profile?.language]}</Typography>
                                        <Typography variant="subtitle2" color="#000000" fontWeight={"bold"}> {detail?.customer_name} </Typography>
                                    </Stack>

                                </Stack>
                                <Divider />
                                <Stack direction={"row"} justifyContent="space-between" paddingX={3} paddingTop={3} >
                                    <Typography variant="h6" color="#D34E4E" > {dict.Amount_Net_TXT[profile?.language]} </Typography>
                                    <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {(Number(detail?.balance)).toLocaleString()} ฿</Typography>
                                </Stack>
                                {/* {
                                    detail?.fee_amount > 0 && <>
                                        <Stack direction={"row"} justifyContent="space-between" paddingX={3}>
                                            <Typography variant="h6" color="#D34E4E" > {dict.Fee_Amount_TXT[profile?.language]} </Typography>
                                            <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {detail?.fee_amount} {detail?.fee_type === "Baht" ? "฿" : "%"}</Typography>
                                        </Stack>
                                        <Stack direction={"row"} justifyContent="space-between" paddingX={3} >
                                            <Typography variant="h6" color="#D34E4E" > {dict.Total_TXT[profile?.language]} </Typography>
                                            <Typography variant="h6" color="#D34E4E" fontWeight={"bold"}> {(Number(detail?.balance + feeForSend)).toLocaleString()} ฿</Typography>
                                        </Stack>
                                    </>
                                } */}

                            </Box>

                        </Stack>
                    </Box>
                </Paper>

                {
                    disableChoiceInputAmount !== "true" ?
                        <Box sx={{ marginTop: 3 }}>
                            <Stack direction="row" spacing={1} mr={2} alignItems={"center"}>
                                <Radio
                                    checked={radioSelected === 'fullAmount'}
                                    onChange={(e) => setRadioSelected(e.target.value)}
                                    value="fullAmount"
                                    name="radio-fullAmount"
                                />
                                <Stack direction={"row"} justifyContent={"space-between"} sx={{ width: "100%" }}>
                                    <Typography>{dict.Full_Amount_TXT[profile?.language]}:</Typography>
                                    {/* <Typography fontWeight={"bold"}>{formatCurrency(detail?.balance + feeForSend)} {dict.Baht_TXT[profile?.language]}</Typography> */}
                                    <Typography fontWeight={"bold"}>{formatCurrency(detail?.balance)} {dict.Baht_TXT[profile?.language]}</Typography>
                                </Stack>

                            </Stack>
                            {/* <Stack direction="row" spacing={1} mt={2} mr={2} alignItems={"center"}>
                                <Radio
                                    checked={radioSelected === 'minimumAmount'}
                                    onChange={(e) => setRadioSelected(e.target.value)}
                                    value="minimumAmount"
                                    name="radio-minimumAmount"
                                />
                                <Stack direction={"row"} justifyContent={"space-between"} sx={{ width: "100%" }}>
                                    <Typography>{dict.Minimum_Amount_TXT[profile?.language]}: </Typography>
                                    <Typography fontWeight={"bold"}>{formatCurrency(minimumAmount)} {dict.Baht_TXT[profile?.language]}</Typography>
                                </Stack>

                            </Stack> */}
                            <Stack direction="row" spacing={1} mt={2}>
                                <Radio
                                    checked={radioSelected === 'specificAmount'}
                                    onChange={(e) => setRadioSelected(e.target.value)}
                                    value="specificAmount"
                                    name="radio-specificAmount"
                                />
                                <TextField
                                    sx={{ ml: 3 }}
                                    label={dict.Specify_Amount_TXT[profile?.language]}
                                    value={amount}
                                    onClick={() => setRadioSelected("specificAmount")}
                                    onChange={(e) => setAmount(e.target.value)}
                                    onBlur={handleBlur}
                                    name="numberformat"
                                    id="formatted-numberformat-input"
                                    endadornment={<InputAdornment position="start">฿</InputAdornment>}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                        style: {
                                            borderRadius: "10px"
                                        },
                                    }}
                                    variant="outlined"
                                />
                            </Stack>
                        </Box>
                        : <Button variant={"contained"} sx={{ width: "100%", height: "50px", mt: 2 }} onClick={() => {
                            navigate('/billpayment/paid' + location.search, {
                                // state: { ...detail, amount: detail?.balance + feeForSend, fee: feeForSend }
                                state: { ...detail, amount: detail?.balance }
                            })
                        }}>
                            {dict.AcceptBtn_TXT[profile?.language]}
                        </Button>
                }

                {alertRequired === true && <Box sx={{ marginTop: 1 }}><Alert severity="error" >{dict.Please_Specify_Amount_TXT[profile?.language]}</Alert></Box>}

            </Container>
            {
                disableChoiceInputAmount !== "true" &&
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Button variant={"contained"} sx={{ position: "fixed", bottom: 2, width: "95%", height: "8%" }} onClick={async () => {
                        let amountConfirm = 0
                        switch (radioSelected) {
                            // case "minimumAmount": amountConfirm = minimumAmount
                            //     break;
                            // case "fullAmount": amountConfirm = detail?.balance + feeForSend
                            case "fullAmount": amountConfirm = detail?.balance
                                break;
                            // the button stays visible while the input has focus (Android keeps focus after the
                            // keyboard closes), so onBlur may not have run: validate the typed amount here too
                            default: amountConfirm = parseFloat(amount) ? clampAmount(amount) : null
                                setAmount(amountConfirm ?? amount)
                                break;
                        }
                        if (amountConfirm === 0 || amountConfirm === null || radioSelected === null || amountConfirm === undefined) {
                            return setAlertRequired(true)
                        }
                        if (version === '2' && amountConfirm <= detail?.balance && detail.terms.length > 0) {
                            // set amount terms
                            let amountTerms = Number(amountConfirm)
                            detail.terms = detail.terms.reduce((acc, item) => {
                                if (item.invoice_balance <= amountTerms) {
                                    acc.push({ 
                                        ...item, 
                                        amount: Math.min(amountTerms, item.invoice_balance)
                                    })
                                    amountTerms -= item.invoice_balance
                                }
                                else if (amountTerms > 0){
                                    acc.push({ 
                                        ...item, 
                                        amount: Math.min(amountTerms, item.invoice_balance)
                                    })
                                    amountTerms = 0
                                }
                                return acc
                            }, []);
                        }
                        if (detail.methodType === '2c2p-normal'){
                            setLoading (true)
                            let payload = {
                                merchantID : "JT04", //fix
                                description : "item 1", //fix
                                amount : amountConfirm,
                                currencyCode : "THB",
                                methodType : detail.methodType,
                                backendReturnUrl : `${process.env.REACT_APP_2C2P_CALLBACK_BACKEND}/2c2p/payment/postback`,
                                frontendReturnUrl : `${process.env.REACT_APP_2C2P_CALLBACK_FRONTEND}/2c2p/order/success`,
                                company_id : checkCompanyId(),
                                contract_id : detail.contract_id,
                                project_id : detail.project_id,
                                project_name : detail.project_name,
                                unit_id : detail.unit_id,
                                unit_number : detail.unit_number,
                                customer_id : profile?.id,
                                customer_name : detail.customer_name,
                                // term_id: checkProductType() === "rental" ? detail.data.contract_term_id : detail.data.term_id,
                                term_name : detail.term_name,
                                term_name_eng : detail.term_name_eng,
                                language : detail.language,
                                fee : detail.fee,
                                terms : detail.terms
                            }
                            const res = await createOrderFor2c2pGateway(payload)
                            if(res?.status === 200){
                                window.location.href = res?.data.webPaymentUrl;
                            }
                            setLoading (false)
                            // return console.log(detail)
                        } 
                        else {
                            navigate('/billpayment/paid' + location.search, {
                                // state: { ...detail, amount: amountConfirm, fee: feeForSend }
                                state: { ...detail, amount: amountConfirm }
                            })
                        }

                        // window.open(`/billpayment/paid${location.search}&amount=${amount}&line_id=${detail.line_id}` +
                        //     `&contract_id=${detail.contract_id}&load_type=${detail.load_type}`
                        //     + `&language=${detail.language}&term_id=${detail.term_id}&reference_id=${detail.reference_id}`
                        //     + `&reference_type=${detail.reference_type}&product_type=${detail.product_type}&payment_id=${detail.payment_id}`
                        //     + `&project_name=${detail.project_name}&method_type=${detail.methodType}&choice_selected=${detail.choiceSelected}`
                        // );
                        return setAlertRequired(false)
                    }
                    }>{dict.AcceptBtn_TXT[profile?.language]}</Button>
                </Box>

            }


        </Box>
        <BackDropLoading
         loading={loading}
         />
        </>
        
    )
}
